import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Modal, Button } from "react-bootstrap";

const ViewProductModal = ({ data, show, handleClose }) => {
  const { reset } = useForm();

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [data, reset]);

  const fields = [
    { label: "Name", value: data?.name },
    { label: "Category", value: data?.category?.name || 'N/A' },
    { label: "Type", value: data?.type },
    { label: "HSN/SAC Code", value: data?.identification_code },
    { label: "SKU", value: data?.sku },
    { label: "Status", value: data?.status },
    { label: "Quantity", value: data?.quantity },
    { label: "Display Price", value: data?.display_price },
    { label: "Selling Price", value: data?.selling_price },
    { label: "Weight", value: data?.weight },
    { label: "Tags", value: data?.tags },
    { label: "In Stock", value: data?.in_stock ? "Available" : "Out of Stock" },
    { label: "Description", value: data?.description },
    { label: "Image URL", value: data?.image },
  ];

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Product Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container px-2">
          <div className="row g-3">
            {fields.map((field, index) => (
              <div className="col-md-6" key={index}>
                <div className="border rounded p-3 bg-white h-100 shadow-sm">
                  <small className="text-muted">{field.label}</small>
                  <div className="fw-semibold mt-1">{field.value || <em className="text-muted">N/A</em>}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger" size="sm" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>

  );
};

export default ViewProductModal;